import { Button } from '@metadevprofile/ui/web';
import { PanelLeftIcon, PanelRightIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSidebar } from '@/common/components/sidebar/sidebar';

export const ToggleSidebar = () => {
  const { open, isMobile, openMobile, toggleSidebar } = useSidebar();
  const { t } = useTranslation('common');

  const shouldShowTrigger = isMobile ? !openMobile : !open;
  if (!shouldShowTrigger) return null;

  return (
    <Button
      variant="ghost"
      isIconOnly
      size="lg"
      onPress={toggleSidebar}
      aria-label={t('ui.sidebar.toggle')}
      className="absolute left-2 top-2 z-10"
    >
      {open ? <PanelRightIcon className="text-muted" /> : <PanelLeftIcon className="text-muted" />}
    </Button>
  );
};
